// tslint:disable: max-line-length
import { Component, inject, Input, OnInit } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { CardInstance } from '@workflow/class/card.service';
import {
  LenderEligibilityQuestionnaire,
  LenderEligibilityQuestion,
  LenderEligibilityFieldOption
} from '@workflow/ecp-workflow/dynamic-app/types/dynamic-eligibility-questions';
import { StringVariableService } from '@workflow/service/string-variable/string-variable.service';

/**
 * different type of field layout
 */
@Component({
  selector: 'ecp-oao-eligibility-review',
  templateUrl: './oao-eligibility-review.component.html',
  standalone: false
})
export class OaoEligibilityReviewComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  /** Membership Eligibility Questionnaire for the lender */
  public dynamicEligibilityQuestionnaire: LenderEligibilityQuestionnaire = {};
  /** Eligibility Questions currently selected */
  public questionnaireSelection: string;
  /** Questions Fields */
  public dynamicEligibilityQuestions: LenderEligibilityQuestion[];
  public selectedques;
  public selectedans;

  @Input() card: CardInstance;

  private get isOla() {
    // eslint-disable-next-line eqeqeq
    return this.card.id === 'ola-eligibility-selection';
  }
  /**
   * Need the question index of the selected question to use it in the automation id
   */
  public arrayIndexofSelectedQuestion = 0;

  constructor(private readonly stringVariableService: StringVariableService) {}

  /** Init */
  public ngOnInit(): void {
    this.dynamicEligibilityQuestions = new Array<LenderEligibilityQuestion>();
    this.getDynamicEligibilityQuestionnaire();
  }

  private getDynamicEligibilityQuestionnaire(): void {
    let pathPrefix = 'api:oaoMemberInformation/';
    if (this.isOla) {
      pathPrefix = 'ola:olaApplicationInformation/';
    }
    const questionnare = this.statefulService.wrap(`${pathPrefix}dynamicEligibility/questionnare`);
    if (questionnare.value) {
      this.dynamicEligibilityQuestionnaire = JSON.parse(questionnare.valueStringOnly);
      this.getQuestionsFromBundle();
      this.questionnaireSelection = this.statefulService.wrap(`${pathPrefix}dynamicEligibility/selectedQuestion`).valueString;
      // Set the index of the matched element here
      this.arrayIndexofSelectedQuestion = this.dynamicEligibilityQuestions?.findIndex((elem) => elem.id === this.questionnaireSelection);
      const selectedques = this.dynamicEligibilityQuestions?.filter((elem) => elem.id === this.questionnaireSelection)[0];
      this.selectedques = [];
      if (selectedques?.questionFields?.length) {
        const questions = selectedques?.questionFields;
        const fieldNamevalues = questions
          .filter((t) => t.label.toLowerCase().includes('name'))
          .map((t) => (this.isDropDown(t.type) ? this.getAns(t.option, t?.selectedLookupItemID) : t.value));
        const filedNoNameValues = questions
          .filter((t) => !t.label.toLowerCase().includes('name'))
          .map((t) => (this.isDropDown(t.type) ? this.getAns(t.option, t?.selectedLookupItemID) : t.value));
        if (filedNoNameValues.length && fieldNamevalues.length) {
          fieldNamevalues.push('/');
        }
        const value = [...fieldNamevalues, ...filedNoNameValues].join(' ');
        this.selectedques.push({ questionText: selectedques?.questionText, value });
      } else {
        // Handling the situation when a single-level question is selected
        this.selectedques.push({ questionText: selectedques?.questionText });
      }
    }
  }

  public showEligibilityQuestions(): boolean {
    return !this.checkIsMember() && this.allowEligibility();
  }

  private allowEligibility() {
    if (this.isOla) {
      return this.stringVariableService.parse('#{admin:olaFeatures/canShowEligibilityQuestions}') as boolean;
    }
    return this.stringVariableService.parse('#{admin:oaoFeatures/canShowEligibilityQuestions}') as boolean;
  }

  private checkIsMember() {
    if (this.isOla) {
      return this.statefulService.wrap('ola:olaApplicationInformation/membership/isMember').value as boolean;
    }
    return this.statefulService.wrap('api:oaoMemberInformation/alreadyMember').value as boolean;
  }

  public getAns(option: LenderEligibilityFieldOption, selectedLookupItemID: number): string {
    // eslint-disable-next-line eqeqeq
    const selectedOpt = option && selectedLookupItemID && option.items.filter((t) => t.lookupItemID == selectedLookupItemID);

    return selectedOpt && selectedOpt.length > 0 ? selectedOpt[0].label : '';
  }

  private getQuestionsFromBundle(): void {
    let pathPrefix = 'api:oaoMemberInformation/';
    if (this.isOla) {
      pathPrefix = 'ola:olaApplicationInformation/';
    }
    if (!!this.dynamicEligibilityQuestionnaire?.questions) {
      this.dynamicEligibilityQuestions = [];
      for (let index = 0; index < this.dynamicEligibilityQuestionnaire.questions.length; index++) {
        const questions = this.statefulService.wrap(`${pathPrefix}dynamicEligibility/questions/$/question`, index).valueStringOnly;
        if (questions) {
          this.dynamicEligibilityQuestions.push(JSON.parse(questions));
        }
      }
    }
  }

  public isDropDown(type: string): boolean {
    return type === 'dropdown';
  }
}
